import styles from './linkButton.module.css'

export default function LinkButton({ text }) {
  return (
    <div className={styles.btn}>
      <button>{text}</button>
    </div>
  )
}
